import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ordersV2Service } from '../pages/oders-v2/services';
import { OrderTab } from '../pages/oders-v2/type';

type CountInfo = {
  orders: number | null;
  notifications: number | null;
  loading: boolean;

};

export const fetchOrders = createAsyncThunk(
  'count/fetchOrders',
  async ({ restaurantId, orderTab }: { restaurantId: number; orderTab: OrderTab }, thunkAPI) => {
    try {
      const response = await ordersV2Service.get({ restaurantId, orderTab });
      return response.data.data?.total;
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  },
);

const initialState: CountInfo = {
  orders: 2,
  notifications: null,
  loading: false,
};

const countSlice = createSlice({
  name: 'countSlice',
  initialState,
  reducers: {
    updateCounts: (state, action) => {
      state.orders = action.payload.orders;
      state.notifications = action.payload.notifications;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching orders:", action.payload);
      });
  },
});

export const { updateCounts } = countSlice.actions;
export default countSlice;
